module.exports = __webpack_public_path__ + "static/media/dashboard-link.a15b4480.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/dashboard-link.md
// module id = 372
// module chunks = 0